import { useQueryClient } from '@tanstack/react-query';

import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { remove } from '../../../redux/api';

import { OIDC_PROVIDERS_QUERY_KEY } from './useOIDCProviders';

/**
 * Hook to delete an OIDC provider.
 * Automatically invalidates the provider list cache and team data on success.
 * Displays success/error toasts automatically.
 */
export default function useDeleteOIDCProvider() {
  const queryClient = useQueryClient();

  return useToastedMutation({
    mutationFn: async (providerId: number) => {
      await remove(`/api/oidc/providers/${providerId}`);
    },
    onSuccess: () => {
      // Invalidate and refetch OIDC providers list
      void queryClient.invalidateQueries({ queryKey: [OIDC_PROVIDERS_QUERY_KEY] });
      // Invalidate team queries to update the OIDC provider count badge
      void queryClient.invalidateQueries({ queryKey: ['teams'] });
    },
    successToastMessage: 'OIDC provider deleted successfully',
    errorToastMessage: 'Failed to delete OIDC provider',
  });
}
